/* eslint-disable */
import 'jquery';

const home_mobile_leftnav = (function() {

  const $left_nav = $('.LeftNav');
  const $logo_cont = $('.LeftNav-logo');
  const $toggle = $('.LeftNav-toggle');

  const init = () => {
    $toggle.on('click', function() {
      handle_toggle_click();
    });
  };

  const handle_toggle_click = () => {
    if ( $toggle.hasClass('is-active') ) {
      $left_nav.addClass('is-active');
      $logo_cont.addClass('is-active');
    } else {
      $left_nav.removeClass('is-active');
      setTimeout(function(){ 
        $logo_cont.removeClass('is-active');
      }, 150);
    }
  };

  return {
    init: init,
  }
})();

$(document).ready(function() {
  home_mobile_leftnav.init();
});
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/components/home_mobile_leftnav.js